import { SELECTION_COLOR } from '@/components/app/editor/selection-chrome/selection-chrome-constants'

export const PLUS_SIZE = 12

// Zoom-invariant: this whole layer is a sibling of the canvas's `transform: scale()` wrapper (see
// its mount comment in `center-canvas/components/screen-space-layers.tsx`) and receives
// screen-pixel centers from `chromeFrameOf`, so every size in this layer is a literal on-screen
// measurement with nothing to counter-scale — the same technique selection chrome uses
// (`visual-layer/selection-chrome-layer/selection-chrome-layer.tsx`). This used to be the other way
// round: the layer lived *inside* the scaled wrapper in document space, and each port square
// counter-scaled itself back down with its own `scale(1 / zoom)`. That worked for the numbered
// squares, but the unlinked out-port "+" (`OutPortPlusGlyph`) was never given the same treatment
// and grew with zoom until it painted over the rotation handle anchored at the same top-edge
// midpoint — the linking overlay sits above per-object chrome in z-order, so the handle vanished
// from ~270% zoom. Moving the whole layer to screen space fixes that "+" and removes the
// counter-scale bookkeeping everywhere else at the same time.
export const PORT_STROKE_COLOR = SELECTION_COLOR
